import { useEffect, useState } from "react";
import Grid, { GridColumn, GridHeader, GridRow } from "../Grid/Grid";
import { Card } from "react-bootstrap";

interface propData {
  data: any[];
  header: any[];
}

const QuoteDetailQuote = (props: propData) => {
  const [rows, setRows] = useState<GridRow[]>([]);
  const [headers, setHeader] = useState<GridHeader[]>([]);

 useEffect(() => {
  if (props.data && props.data.length > 0 && props.header.length > 0) {
    let rows: GridRow[] = [];

    for (let i = 0; i < props.data.length; i++) {
      let columns: GridColumn[] = [];

      for (let j = 0; j < props.header.length; j++) {
        const fieldKey = props.header[j].key;  // ✅ Get key from header
        columns.push({ value: props.data[i][fieldKey] });  // ✅ Use key to access data
      }

      rows.push({ data: columns });
    }

    setRows(rows);
  }
}, [props.data]);

  useEffect(() => {
    if (props.header && props.header.length > 0) {
      let header: GridHeader[] = [];
      for (var i in props.header) {
        header.push({
          title: props.header[i].title,
          class:  props.header[i].headerAlignment == 'L' ? 'text-start' : props.header[i].headerAlignment == 'R' ?  'text-end'  :  "text-center",
        });
      }
        setHeader(header);
    }
  }, [props.header]);

  return (
    <>
      <Card
        className="card-style form-style invoice-call-picture-card"
        style={{ marginBottom: 50 }}
      >
        {headers.length > 0 ? <Grid headers={headers} rows={rows} /> : <></>}
      </Card>
    </>
  );
};

export default QuoteDetailQuote;
